import { Route, Routes, useParams } from "react-router-dom"
import ActivityIncomesTrackingList from "./list"
import CreateActivityIncome from "./list/create"
import EditActivityIncome from "./list/edit"
import DuplicateActivityIncome from "./list/duplicate"

const ActivityIncomesTracking: React.FC = () => (
  <Routes>
    <Route index element={<ActivityIncomesTrackingList />} />
    <Route path="create" element={<CreateActivityIncome />} />
    <Route path=":activity_income_id">
      <Route path="edit" element={<EditActivityIncome />} />
      <Route path="duplicate" element={<DuplicateActivityIncome />} />
    </Route>
  </Routes>
)

export function useActivityIncomeId() {
  return useParams<{ activity_income_id: string }>().activity_income_id
}

export default ActivityIncomesTracking
